import React, { Component } from "react";

import lexmarkMX711 from '../../Lexmark-MX711.png';

class Menu extends Component {
    render() {
        return (
            <div id="menu-location" className="menu menu-box-bottom" data-menu-height="310" data-menu-effect="menu-over">
                <div className="top-30 center-text">
                    <h2 id="location-name" className="uppercase bold"></h2>
                    <p id="location-address" className="under-heading bottom-20" style={{textTransform: 'capitalize'}}></p>
                    <div className="center-text-huge" style={{textAlign: 'left'}}>
                        <div className="link-list link-list-1 printers-list content top-30 bottom-0 touchmove">
                            <a href="#">
                                <img src={lexmarkMX711} />
                                <span className="font-13">Lexmark</span>
                                <span className="font-13">-</span>
                                <span className="font-13">חדר מכונות צילום</span>
                                {/* add availablity and colorful/duplex */}
                                {/* <i className="far fa-angle-right"></i> */}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Menu;


// WEBPACK FOOTER //
// ./src/components/menus/location.js